import {useHistory} from 'react-router-dom';

export function Redirect(props: { to: string }) {
    const history = useHistory();
    props.to && setTimeout(() => history.push(props.to), 0);
    return null;
}
